var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.53125C13.8164 0.53125 17.7188 4.43359 17.7188 9.25C17.7188 14.0664 13.8164 17.9688 9 17.9688C4.18359 17.9688 0.28125 14.0664 0.28125 9.25C0.28125 4.43359 4.18359 0.53125 9 0.53125ZM9 16.2812C12.8672 16.2812 16.0312 13.1523 16.0312 9.25C16.0312 5.38281 12.8672 2.21875 9 2.21875C5.09766 2.21875 1.96875 5.38281 1.96875 9.25C1.96875 13.1523 5.09766 16.2812 9 16.2812ZM11.1445 12.625L8.15625 10.4453C8.05078 10.375 8.01562 10.2344 8.01562 10.1289V4.32812C8.01562 4.11719 8.19141 3.90625 8.4375 3.90625H9.5625C9.77344 3.90625 9.98438 4.11719 9.98438 4.32812V9.32031L12.3047 11.043C12.5156 11.1836 12.5508 11.4297 12.4102 11.6406L11.7422 12.5195C11.6016 12.7305 11.3555 12.7656 11.1445 12.625Z",
    fill: "#E06262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOrange);
export default __webpack_public_path__ + "static/media/time_orange.d6ca60a7098f76099bf0e5f11ba7469b.svg";
export { ForwardRef as ReactComponent };